var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCertificationIcon = function SvgCertificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M13.658 3.267 8.214 1.04a.57.57 0 0 0-.425 0L2.344 3.267A.548.548 0 0 0 2 3.773v2.704c0 3.724 2.286 7.074 5.789 8.482a.557.557 0 0 0 .42 0C11.713 13.551 14 10.201 14 6.477V3.773a.55.55 0 0 0-.342-.506Zm-.77 3.21C12.889 9.643 11 12.558 8 13.86c-2.92-1.266-4.889-4.13-4.889-7.383v-2.34l4.889-2 4.889 2v2.34ZM7.387 8.32l2.389-2.352a.563.563 0 0 1 .786 0 .542.542 0 0 1 0 .774L7.778 9.48a.563.563 0 0 1-.786 0L5.439 7.951a.542.542 0 0 1 0-.774.563.563 0 0 1 .786 0L7.386 8.32Z"
  })));
};
export default SvgCertificationIcon;